import requester from '@/utils/request'
export const commentService = {
  // 类型，0-post文章 1-nft商品
  thumbUpByPost: (data: any) => requester.post('/common/v1/thumbUp', data),
  // 不同关联场景创作者统计信息 -- collections
  collectionsStatistics: (data?: any) =>
    requester.post('/common/creator/collections/statistics', data),
  // 不同条件筛选创作者列表 -- collections
  creatorList: (data: any) => requester.post('/common/creator/page/info', data),
  // 不同条件筛选post列表 -- collections
  creatorPostList: (data: any) => requester.post('/common/creator/page/post/info', data),
  // 【Referral】获取推荐创作者的奖励数据
  referralRewardRecord: (data: any) => requester.post('/common/creator/referralRewardRecord', data),
  // 【Referral】获取我邀请的创作者列表
  queryReferralCreators: (data: any) =>
    requester.post('/common/creator/queryReferralCreators', data),
  // 【Referral】获取我邀请的粉丝列表
  queryReferralUsers: (data: any) => requester.post('/common/creator/queryReferralUsers', data),
  // 【Referral】获取我的邀请奖励概览
  queryReferralSummary: () => requester.post('/common/creator/queryReferralSummary', {}),
  // 【Referral】获取我的邀请奖励明细
  referralEarningDetail: (data: any) =>
    requester.post('/common/creator/referralEarningDetail', data),
  // 判断用户 IP 获取支付区域
  getPaymentArea: () => requester.post('/charge/common/get-payment-area', {}),
  // 获取ip所属国家列表
  getCountry: () => requester.post('/common/get-country', {}),
  // 获取国家列表
  getCountryList: () => requester.post('/area/find-country-list', {}),
  //根据父级id查询下级区域信息
  getAreaList: (areaId: number | string) => requester.post('/area/find-next?areaId=' + areaId, {}),
  // google twitter 登录使用
  loginAuthCode: (authCode: string) =>
    requester.post('/dfans/v1/login/auth-code?authCode=' + authCode),
  // 诊断报告
  diagnoseReport: () => requester.post('/track/diagnostic', {}),
  // 获取评论设置
  getCommentSetting: () => requester.post('/common/creator/get-comment-setting', {}),
}
